<template>
	<div>
		<!-- delete dialog -->
		<bee-delete-dialog
			v-model="deleteDialog"
			moduleType="filters"
			:ids="deleteItemId"
			@on-delete="fetchFilters"
		>
			{{$t('are-you-sure-you-want-to')}} 
			<span class="text-uppercase error--text">{{$t('delete')}}</span> 
			{{$t('Filters.the-filter')}}
		</bee-delete-dialog>

		<!-- add/edit dialog -->
		<v-dialog
			v-model="dialog"
			width="400"
			:persistent="dialogLoading"
		>
			<v-form ref="form" @submit.prevent="submit">
				<v-card class="rounded-medium">
					<v-card-title class="justify-center text-uppercase text-h6 mb-3">
						{{ editItemId ? $t('edit') : $t('add')}} {{$t('Filters.filter')}}
					</v-card-title>
					<v-card-text class="pb-2">
						<v-row class="flex-column mt-0">
							<v-col class="py-0">
								<v-text-field
									v-model="name"
									:label="$t('inputs.name')"
									outlined
									dense
									class="rounded-small"
									:rules="rules.required"
								></v-text-field>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-spacer/>
						<v-btn
							type="submiy"
							color="primary"
							class="rounded-small"
							:loading="dialogLoading"
							:disabled="dialogLoading"
						>
							{{$t('save')}}
						</v-btn>
						<v-btn
							@click="dialog = false"
							class="rounded-small"
							:disabled="dialogLoading"
						>
							{{$t('cancel')}}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<!-- filters -->
		<v-card class="rounded-medium mb-3">
			<v-card-text class="pa-3">
				<v-row class="align-center">
					<!-- add -->
					<v-col md="8" cols="12" class="text-sm-start text-center">
						<v-btn
							dark
							color="darkGreen"
							class="rounded-small"
							@click="dialog = true"
						>
							<v-icon>mdi-plus</v-icon>
							{{$t('Filters.add-new-filter')}}
						</v-btn>
					</v-col>
					<!-- search -->
					<v-col md="4" cols="12" class="d-flex flex-sm-row flex-column align-center text-md-start text-center">
						<v-text-field
							v-model="search"
							:label="$t('search')"
							hide-details
							outlined
							dense
							prepend-inner-icon="mdi-magnify"
							class="rounded-medium align-self-stretch me-sm-6 mb-sm-0 mb-5"
						></v-text-field>
						<v-btn
							:color="isFiltered ? null : 'primary'"
							class="rounded-small"
							@click="isFiltered = !isFiltered"
						>
							{{isFiltered ? $t('cancel') : $t('search')}}
						</v-btn>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
		
		<!-- table -->
		<v-data-table
			:headers="headers"
			:items="loading ? [] : filteredFilters"
			:loading="loading"
			:items-per-page="15"
			class="elevation-3 rounded-medium"
		>
			<template v-slot:item.actions="{ item }">
				<v-btn
					color="blue darken-4"
					dark
					small
					class="me-1 px-1 flex-shrink-1"
					min-width="20px"
					@click="editItemId = item.id; dialog = true;"
				><v-icon>mdi-pencil</v-icon></v-btn>
				<v-btn
					color="red darken-1"
					dark
					small
					class="px-1"
					min-width="20px"
					@click="deleteDialog = true; deleteItemId = item.id"
				>
					<v-icon>mdi-delete</v-icon>
				</v-btn>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import rules from '@/helpers/validation rules'
import { mapGetters, mapState } from 'vuex';
export default {
	name: 'Filters',

	data: () => ({
		dialog: false,
		deleteDialog: false,
		editItemId: null,
		deleteItemId: null,

		// filters
		search: null,
		isFiltered: null,

		// helpers
		loading: false,
		dialogLoading: false,
		rules,

		// data
		name: null
	}),

	watch: {
		dialog(val) {
			if (val) {
				this.name = this.editItemId ? this.getFilterById(this.editItemId).name : null
			} else {
				this.name = null;
				this.editItemId = null;
				this.$nextTick(() => {
					this.$refs.form.resetValidation();
				})
			}
		}
	},

	computed: {
		...mapState({
			filters: state => state.filters.filters	
		}),

		...mapGetters({
			getFilterById: 'filters/getFilterById'
		}),

		filteredFilters() {
			return this.filterByName(this.isFiltered, this.filters, this.search);
		},

		headers() {
			return [
				{ text: this.$t('headers.name'), value: 'name', align: 'center', class: 'primary--text', cellClass: 'primary--text' },
				{ text: this.$t('headers.actions'), value: 'actions', align: 'center', sortable: false },
			]
		}
	},

	methods: {
		submit() {
			if (this.$refs.form.validate()) {
				const actionName = this.editItemId ? 'update' : 'create';
				this.dialogLoading = true;
				this.$store.dispatch(`filters/${actionName}`, {
					id: this.editItemId,
					name: this.name
				}).then(() => {
					const message =
						this.editItemId
							? this.$t('$-is-updated-successfully', { name: this.$t('Filters.filter') })
							: this.$t('$-is-created-successfully', { name: this.$t('Filters.filter') });
					this.$eventBus.$emit('show-snackbar', false, message);
					this.dialog = false;
					this.fetchFilters();
				}).finally(() => {
					this.dialogLoading = false;
				})
			}
		},

		fetchFilters() {
			this.loading = true;
			this.$store.dispatch('filters/fetchAll')
				.finally(() => {
					this.loading = false;
				})
		}
	},

	created() {
		this.fetchFilters();
	}
}
</script>

<style>

</style>